















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

export enum FlatSelectorSwitchColorSeparator {
  Primary = 'flat-selector-switch--separator-primary',
  Secondary = 'flat-selector-switch--separator-secondary',
}

@Component
export default class FlatSelectorSwitch extends Vue {
  @Prop({ default: FlatSelectorSwitchColorSeparator.Primary }) private colorSeparator!: FlatSelectorSwitchColorSeparator;


  private isOpen: boolean = false;
  private showOptionsTimeout!: any;


  get showOptions() {
    return this.isOpen && this.hasSlot('options');
  }

  private hasSlot(slotName: string) {
    return !!this.$slots[slotName];
  }


  private setIsOpen(value: boolean) {
    window.clearTimeout( this.showOptionsTimeout );
    this.showOptionsTimeout = setTimeout(
      () => { this.isOpen = value; },
      500,
    );
  }
}
